import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';

import css from './style.module.scss';

interface IProps {
  children: ReactNode;
  gap?: '4' | '8' | '12' | '16' | '20' | '24' | '32';
  width?: 'full';
  align?: 'spaceBetween' | 'center' | 'end';
  direction?: 'column' | 'column_reverse';
  flex?: '1',
  className?: string;
}

const Actions: FC<IProps> = ({ children, gap, width, align, direction, className, flex }) => (
  <div
    className={classNames(
      css.actions,
      {
        [css[`actions_gap_${gap}`]]: gap,
        [css[`actions_width_${width}`]]: width,
        [css[`actions_align_${align}`]]: align,
        [css[`actions_direction_${direction}`]]: direction,
        [css[`actions_flex_${flex}`]]: flex,
      },
      className,
    )}
  >
    {children}
  </div>
);

export default Actions;
